export default "__VITE_ASSET__D93eywm7__"